import compileSymbols from '~/utils/compileSymbols';

const types = ['MOUNTED'];

export default compileSymbols(types, 'application');
